import axios from "axios";
import Config from "src/config";

const v2_actionCriarCredenciais = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.url_prod}/api/v2/${clienteId}/credenciais/criar`,
        data
    });
};

export default v2_actionCriarCredenciais;
